module.exports = __webpack_public_path__ + "static/media/red_tick_mark.8c996168.svg";